module.exports = __webpack_public_path__ + "img/067-hong-kong.f9ed43f1.svg";